import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ValidationProtocol } from '../../models/validationProtocol';

@Component({ standalone:false,
  selector: 'app-select-validation-protocol-dialog',
  templateUrl: 'select-validation-protocol-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['select-validation-protocol-dialog.component.scss']
})
export class SelectValidationProtocolComponent {
  title: string= "Select the validation to add a validation override";
  message: string = "Caution: By selecting the validation below, you will be changing the default validation behavior.";
  confirmButtonText = "Add Override";
  cancelButtonText = "Cancel";
  validationProtocols!: ValidationProtocol[];
  selectedValidationProtocol?: ValidationProtocol;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<SelectValidationProtocolComponent>) {
    if(data){
        this.title=data.title || this.title;
        this.message = data.message || this.message;
        this.validationProtocols = data.validationProtocols;
        if (data.buttonText) {
            this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
            this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
    }
  }

  get canClickConfirm(): boolean{
    return this.selectedValidationProtocol!=undefined;
  }

  onConfirmClick(): void {
    this.dialogRef.close(this.selectedValidationProtocol);
  }
  onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

}